// Gestion du scrollTo pour les ancres
export default function btnsAnchor() {
    const tabAnchor = document.getElementsByClassName('btn-anchor');
    if ( tabAnchor ) {
        Array.from(tabAnchor, elt => {
            elt.addEventListener('click', function (evt) {
                const dataName = this.dataset.anchor;
                document.getElementById(dataName).scrollIntoView({
                    behavior: "smooth"
                });
                evt.preventDefault();
            });
        })
    }
    else {
        console.log('Aucunes ancres à traiter');
    }
}
